export default class ListItem {
  constructor({ item = {}, selected = false, currentQuantity = 0 }) {
    Object.assign(this, item)
    this.selected = selected
    this.currentQuantity = currentQuantity
  }
}



// WEBPACK FOOTER //
// ./src/models/ListItem.js